import { Slider } from 'cc';

declare module 'cc' {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    namespace Slider {
        enum EventType {
            SLIDE = 'slide',
            PROGRESS_CHANGED = 'progress-changed',
        }
    }
}
enum EventType {
    SLIDE = 'slide',
    PROGRESS_CHANGED = 'progress-changed',
}

Slider.EventType = EventType;

const originalDescriptor = Object.getOwnPropertyDescriptor(Slider.prototype, 'progress');
const originSetter = originalDescriptor.set;
originalDescriptor.set = function set(this: Slider, value: string) {
    const oldProgress = this.progress;
    originSetter.call(this, value);
    if (oldProgress !== this.progress) {
        this.node.emit(EventType.PROGRESS_CHANGED, value);
    }
};
Object.defineProperty(Slider.prototype, 'progress', originalDescriptor);

export default Slider;
